export default __webpack_public_path__ + "static/media/questionnaire.0d7f77dd.svg";